import { GlobalProvider } from './context/GlobalProvider';
import Home from './components/Home/Home';

interface Props {
  rtl: boolean
}

function App({ rtl }: Props) {
  return (
    <GlobalProvider >
      <Home rtl={rtl} />
    </GlobalProvider>
  );
}

export default App;